export default "__VITE_ASSET__CRyXFCUU__"